"use client";

/*
 * Límite de error del área autenticada.
 *
 * `global-error.tsx` sólo entra en juego cuando el fallo escapa del layout
 * raíz, lo que en la práctica significa que la aplicación entera ya se ha
 * caído. Este límite atrapa los fallos de renderizado dentro de /app —
 * pacientes, sesiones, chat— los reporta con su stack y deja al terapeuta una
 * salida que no es recargar a ciegas.
 */

import { useEffect } from "react";
import { reportarFallo } from "@/lib/observabilidad/reportarFallo";

export default function ErrorDeAplicacion({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    reportarFallo(error, { origen: "limiteErrorApp", digest: error.digest });
  }, [error]);

  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-4 px-6 text-center">
      <h2 className="text-xl font-semibold text-zinc-800">
        Algo ha fallado en esta pantalla
      </h2>
      <p className="max-w-md text-sm text-zinc-500">
        El error se ha registrado y el equipo puede verlo. Tus datos no se han
        perdido.
      </p>
      <button
        type="button"
        onClick={reset}
        className="rounded-md bg-indigo-600 px-4 py-2 text-sm font-medium text-white hover:bg-indigo-700"
      >
        Reintentar
      </button>
    </div>
  );
}
